import React, {useEffect, useState} from 'react'
import { useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../../components/recoil/atoms/Menus";

import HeaderUserTitle from "../components/includes/HeaderUserTitle";
import { PassedMonths,ChangeSimpleDateString, addThousandPoint, ChangeMobileFormat,isNull, 
          GetSimpleDateTimeFromJDateTime,GetAdminAttendanceStatusString,GetChildrenState, 
          isObjEmpty,GetPaymentStatus,GetMonthDateString,
        } from "../../components/common/Common";

import calendarIcon from "../../img/icon/icon-view-calendar.svg";
import kidsIcon from "../../img/icon/icon-view-kids.svg";
import classIcon from"../../img/icon/icon-view-class.svg";
import main01Icon from "../../img/icon/icon-center-main01.svg";

//수업세부현황
const ClassStudy = () => {
  const { ch_idx,cl_idx } = useParams();
  const [varParentMenus,setParentMenus] = useRecoilState(ParentsMenus);

  //정보저장변수
  const [varMemberInfo,setMemberInfo] = useState({}); //원생정보
  const [varClassInfo,setClassInfo] = useState({});   //수업정보
  const [varPaymentInfo,setPaymentInfo] = useState({}); //결제정보
  const [varAttendanceList,setAttendanceList] = useState([]); //출석내역

  //원생 수업상세정보 호출
  const GetClassInformation = async() => {
    const sendData = {ch_idx:ch_idx,cl_idx:cl_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_class_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results.length > 0) setMemberInfo(datas.results[0]);
        if(datas.classInfo.length > 0) setClassInfo(datas.classInfo[0]);

        if(datas.paymentInfo.length > 0){
          setPaymentInfo(datas.paymentInfo[0]);
        } 

        if(datas.studys.length > 0) {
          const attendanceList = datas.studys;
          const newList = attendanceList.filter(el=>!isNull(el.cs_idx));
          setAttendanceList(newList);
        } 
      } else {
        alert(datas.message);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varParentMenus);
    setParentMenus({showMenu:false,gotoMain:0});
    GetClassInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="vh-content normal-wrap class-view-wrap">
      <HeaderUserTitle varPageTitle={'클래스 현황'}/>
      <div className="vh-content-body">
        {/* 원생정보 */}
        <div className="class-info">
          <div className="class-left">
            <div className="name">{varMemberInfo.ch_name}</div>
            <div>{PassedMonths(varMemberInfo.ch_birthday)+"개월"} ({ChangeSimpleDateString(varMemberInfo.ch_birthday)}) ({GetChildrenState(varMemberInfo.ch_status)})</div>
          </div>
        </div>
        <div className="view-con">
          <div className="center-wrap">
             {/* 수업정보 */}
            <div className="con con01">
              <div className="img-box">
                <img src={main01Icon} alt=""/>
                <span>{varClassInfo.cl_type===1?"마마몽떼":"플라이"}<br/>{varClassInfo.cr_name}</span>
              </div>
              <div className="txt-box">
                <p className="class-tit">{varClassInfo.cl_name}</p>
                <div className="class-date flex">
                  <img src={calendarIcon} alt=""/>
                  <p>{ChangeSimpleDateString(varClassInfo.sm_sdate)} ~ {GetMonthDateString(varClassInfo.sm_edate)}</p>
                </div>
                <div className="class-kids flex">
                  <img src={kidsIcon} alt=""/>
                  <p>{varClassInfo.vl_name} ({varClassInfo.ch_attendance})</p>
                </div>
                <div className="class-state flex">
                  <img src={classIcon} alt=""/>
                  <p>수업 차수 {varClassInfo.ycount}/{varClassInfo.tcount} ˙ 출석 {varClassInfo.ecount} ˙ 결석 {varClassInfo.xcount}</p>
                </div>
              </div>
            </div>
            {/* 결제정보 */}
            {varClassInfo.cl_mode!==1?null:
              isObjEmpty(varPaymentInfo)?
                <div className="con con02">
                  <div className="con-tit">결제 현황
                    <div className="con-state">
                      <span>미결제</span>
                    </div>
                  </div>
                </div>
              :
              <div className="con con02">
                <div className="con-tit">결제 현황
                  <div className="con-state">
                    <span>{GetPaymentStatus(varPaymentInfo.ph_status)}</span>
                    <span>₩ {addThousandPoint(varPaymentInfo.ph_price)} 원</span>
                  </div>
                </div>
                <div className="con-box">
                  <ul>
                    <li>
                      <p>청구서 구분</p>
                      <div>{varPaymentInfo.cl_name}</div>
                    </li>
                    <li>
                      <p>수업 구분</p>
                      <div>{varPaymentInfo.cl_mode===1?"정규수업":"보강수업"}</div>
                    </li>
                    <li>
                      <p>학부모</p>
                      <div>{varPaymentInfo.mem_name} ({ChangeMobileFormat(varPaymentInfo.mem_mobile)})</div>
                    </li>
                    <li>
                      <p>청구서 ID</p>
                      <div>{varPaymentInfo.ivc_id}</div>
                    </li>
                    <li>
                      <p>결제 상태</p>
                      <div>{GetPaymentStatus(varPaymentInfo.ph_status)}
                        {varPaymentInfo.ph_status===2?"("+GetSimpleDateTimeFromJDateTime(varPaymentInfo.ph_pdate)+")":null}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            }
            <div className="con con03">
                <div className="con-tit">출결 현황</div>
                <div className="con-box">
                  <ul style={{height:"330px"}}>
                    {varAttendanceList.map((attendance,j)=>(
                      <li key={'attendance_'+j}>
                        <p>{attendance.cs_index}차 수업</p>
                        <div>{attendance.cl_name} {GetAdminAttendanceStatusString(attendance)}</div>
                      </li>
                    ))}
                  </ul>
                </div>
            </div>
          </div>
        </div>
			</div>
    </div>
  )
}
export default ClassStudy;